import { Button, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import { ReactNode, useState } from 'react';
import EditTabs from '../organisms/EditTabs';
import { useIsMutating } from '@tanstack/react-query';
import { EntityEditTabType } from '../../@types';

const makeStyles = (disablePadding: boolean) => ({
  dialogContent: {
    pt: '8px !important',
    ...(disablePadding && { px: '0 !important' }),
  },
});

export type FormLayoutProps = {
  isEdit?: boolean;
  label?: string;
  onSave: () => void;
  children?: ReactNode;
  onClose?: () => void;
  actionButtonLabel?: string;
  editEntity?: EntityEditTabType;
  showEditTabs?: boolean;
  disablePadding?: boolean;
  inputSpacing?: number;
  disableSubmit?: boolean;
  titleAlign?: 'left' | 'center' | 'right';
};

const FormModalLayout = ({
  isEdit = false,
  onSave,
  children,
  label,
  onClose,
  actionButtonLabel,
  editEntity,
  showEditTabs = true,
  disablePadding = false,
  inputSpacing = 2,
  disableSubmit = false,
  titleAlign,
}: FormLayoutProps) => {
  const [selectedTabIdx, setSelectedTabIdx] = useState(0);

  const isMutating = useIsMutating();
  const styles = makeStyles(disablePadding);

  const saveButtonDisabled = disableSubmit || !!isMutating;

  const handleTabChange = (_event: React.SyntheticEvent, newTabIndex: number) => {
    setSelectedTabIdx(newTabIndex);
  };

  return (
    <>
      {!!label && (
        <DialogTitle variant='h4' gutterBottom sx={{ textAlign: titleAlign }}>
          {label}
        </DialogTitle>
      )}
      <DialogContent sx={styles.dialogContent}>
        {isEdit && showEditTabs ? (
          <EditTabs editEntity={editEntity} selectedTab={selectedTabIdx} handleTabChange={handleTabChange}>
            {children}
          </EditTabs>
        ) : (
          <Stack spacing={inputSpacing}>{children}</Stack>
        )}
      </DialogContent>
      {selectedTabIdx === 0 && (
        <DialogActions>
          {onClose && (
            <Button variant='outlined' onClick={onClose}>
              Cancel
            </Button>
          )}
          <Button variant='contained' onClick={onSave} disabled={saveButtonDisabled}>
            {actionButtonLabel ?? 'Save'}
          </Button>
        </DialogActions>
      )}
    </>
  );
};

export default FormModalLayout;
